import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Verification } from "./App";
import { PasswordReset } from "./auth/PasswordReset";
import { EmailConfirmation } from "./auth/VerifyEmail";
import {
	MonthlyCalendarPopup,
	WeeklyCalendarPopup,
} from "./components/Calendar/Calendar";
import { Changelog } from "./components/Changelog";
import { ClientProject } from "./components/Clients/ProjectPage/ClientProject";
import { CloudViewerContainer } from "./components/CloudViewer/CloudViewer";
import { MainMenu } from "./components/Dashboard/MainMenu";
import OnBoarding from "./components/Employee/OnBoarding";
import { ErrorPage } from "./components/Error";
import LandingPage from "./components/Landing/Index";
import { AuthCallback } from "./components/Login/AuthCallback";
import NavBarRework from "./components/NavBarRework/NavBarRework";
import { QRDownload } from "./components/QR Download/QRDownload";
import { ProjectStatusReport } from "./components/Report/ProjectReport";
import { ANNOUNCEMENT_ROUTES } from "./components/Routes/AnnouncementRoutes";
import { ASSIGNMENT_ROUTES } from "./components/Routes/AssignmentRoutes";
import { CALENDAR_ROUTES } from "./components/Routes/CalendarRoutes";
import { CLIENT_ROUTES } from "./components/Routes/ClientRoutes";
import { EMPLOYEE_ROUTES } from "./components/Routes/EmployeeRoutes";
import { INVOICE_ROUTES } from "./components/Routes/InvoiceRoutes";
import { POINT_OF_CONTACT_ROUTES } from "./components/Routes/PointOfContactRoutes";
import { PROJECT_ROUTES } from "./components/Routes/ProjectRoutes";
import { RESOURCE_ROUTES } from "./components/Routes/ResourceRoutes";
import { RFI_ROUTES } from "./components/Routes/RFIRoutes";
import { SUBMITTAL_ROUTES } from "./components/Routes/SubmittalRoutes";
import { TASK_ROUTES } from "./components/Routes/TaskRoutes";
import SettingsPage from "./components/Settings/Settings";

export function AppRoutes() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<LandingPage />} />

				{/* All routes here are checked for authentication. */}
				<Route element={<Verification />}>
					<Route element={<NavBarRework />}>
						<Route path="/main_menu" element={<MainMenu />} />

						{PROJECT_ROUTES}
						{TASK_ROUTES}
						{SUBMITTAL_ROUTES}
						{RFI_ROUTES}
						{EMPLOYEE_ROUTES}
						{CALENDAR_ROUTES}
						{ASSIGNMENT_ROUTES}
						{INVOICE_ROUTES}
						{POINT_OF_CONTACT_ROUTES}
						{CLIENT_ROUTES}
						{ANNOUNCEMENT_ROUTES}
						{RESOURCE_ROUTES}

						<Route path="/settings/" element={<SettingsPage />} />

						<Route path="/changelog/" element={<Changelog />} />

						<Route
							path="/cv/:project_id/:folder_name"
							element={<CloudViewerContainer />}
						/>
					</Route>

					<Route
						path="/calendar/monthly/popup"
						element={<MonthlyCalendarPopup />}
					/>
					<Route
						path="/calendar/weekly/popup"
						element={<WeeklyCalendarPopup />}
					/>
					<Route path="/employees/onboarding/" element={<OnBoarding />} />
					<Route
						path="/projects/project_status_report"
						element={<ProjectStatusReport />}
					/>
				</Route>

				<Route path="/clients/projects" element={<ClientProject />} />

				<Route path="/email/confirm/:key" element={<EmailConfirmation />} />
				<Route path="/password/reset/:key" element={<PasswordReset />} />

				<Route path="/auth-callback" element={<AuthCallback />} />

				<Route path="/afs/qr-download/:project_id" element={<QRDownload />} />

				<Route path="*" element={<ErrorPage />} />
			</Routes>
		</Router>
	);
}

